const team = [
  {
    name: 'Aleksander Novak',
    role: 'CEO & Co-Founder',
    bio: 'Visionary leader with 12+ years in mobile software development and product strategy.',
  },
  {
    name: 'Milena Petrović',
    role: 'Lead iOS Developer',
    bio: 'Swift expert and Apple platform specialist with a passion for clean, performant code.',
  },
  {
    name: 'Dragan Ilić',
    role: 'Head of Security',
    bio: 'Cybersecurity veteran ensuring every product meets the highest privacy standards.',
  },
  {
    name: 'Jovana Marković',
    role: 'UI/UX Designer',
    bio: 'Crafting intuitive, beautiful interfaces that delight users on every screen.',
  },
  {
    name: 'Stefan Đorđević',
    role: 'Backend Engineer',
    bio: 'Building robust, scalable infrastructure that powers seamless app experiences.',
  },
];

export default function TeamSection() {
  return (
    <section id="team" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="text-teal-500 text-xs font-semibold tracking-widest uppercase">Our Team</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Expert Developers
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            A passionate team united by a love for great software and the iOS ecosystem.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {team.map((member, idx) => (
            <div
              key={member.name}
              className={`rounded-3xl overflow-hidden cursor-default bg-gray-50 ${
                idx === 2 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-teal-100 mb-5">
                  <i className="ri-user-line text-teal-600 text-xl" />
                </div>
                <div className="font-bold text-gray-900 text-lg mb-1">{member.name}</div>
                <div className="text-teal-600 text-sm font-medium mb-4">{member.role}</div>
                <p className="text-gray-500 text-sm leading-relaxed">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
